
import React from 'react';
import { Building2, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ClientsHeaderProps {
  onNewClient?: () => void;
}

const ClientsHeader: React.FC<ClientsHeaderProps> = ({ onNewClient }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg flex items-center justify-center">
          <Building2 className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-montserrat font-bold text-gray-900">Clientes</h1>
          <p className="text-gray-600">Gerencie seus clientes do Portal Átomos</p>
        </div>
      </div>
      <Button
        onClick={onNewClient}
        className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-200"
      >
        <Plus className="w-4 h-4 mr-2" />
        Novo Cliente
      </Button>
    </div>
  );
};

export default ClientsHeader;
